var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9994 5.83317V3.33317C14.9994 2.4165 14.2494 1.6665 13.3327 1.6665H6.66602C5.74935 1.6665 4.99935 2.4165 4.99935 3.33317V5.83317H4.16602V10.8332L6.66602 15.8332V18.3332H13.3327V15.8332L15.8327 10.8332V5.83317H14.9994ZM6.66602 3.33312H13.3327V5.83312H11.6577V4.16646H10.8243V5.83312H9.16602V4.16646H8.33268V5.83312H6.66602V3.33312ZM11.6658 15.4415L14.1658 10.4415V7.49988H5.8325V10.4415L8.3325 15.4415V16.6665H11.6658V15.4415Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.c014202d3a8290e78660947a125f143f.svg";
export { ForwardRef as ReactComponent };